import { Avatar, Stack, Typography } from '@mui/material';
import React from 'react'
import { StandardTableActions } from '../../../Components/StandardTableActions/StandardTableActions';
import { DataTable } from '../../../Components/Table/DataTable';
import { IDataTableProps, MobileLogoRenderType, RenderType } from '../../../Components/Table/interfaces/IDataTableProps';
import { useAppSelector, IStoreState, useAppDispatch } from '../../../redux';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { CustomButton } from '../../../Components/CustomButton';
import { UpsertTaxInfoDialog } from './dialogs/UpsertTaxInfoDialog';
import { ITaxInfo } from '../../../redux/settings/tax-info/tax-info.types';
import { clearTaxInfoListSync, defaultTaxInfo, fetchTaxInfoListAsync } from '../../../redux/settings/tax-info';

export const TaxInfoTable = () => {
    const {
        data: taxInfoList,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.settings.tax.tax_info_list);
    const dispatch = useAppDispatch();

    const [pagination, setPagination] = React.useState({
        pageNumber: 1,
        rowsPerPage: 10,
    });
    const [openUpsertDialog, setOpenUpsertDialog] = React.useState<ITaxInfo | null>(null);


    const dataTableProps: IDataTableProps = {
        isPagination: true,
        rowsPerPageOptions: 25,
        isDataLoading: false,
        mobileLogo: {
            type: MobileLogoRenderType.reactNode,
            onMobileLogoRender: (data: any) => {
                return (
                    <Avatar
                        sx={{
                            width: 45,
                            height: 45,
                            color: "#fff",
                            ml: "-8px",
                            mr: 2,
                        }}
                    ></Avatar>
                );
            },
        },

        columns: [
            {
                key: "view",
                headerName: "Actions",
                fieldName: "",
                headingAlign: "center",
                renderType: RenderType.CUSTOM_RENDER,
                onRowCellRender: (value, row: ITaxInfo) => {
                    return (
                        <StandardTableActions
                            onEditClick={() => setOpenUpsertDialog(row)}
                        />
                    );
                },
            },
            {
                key: "tax_name",
                headerName: "Tax Name",
                fieldName: "tax_name",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "tax_rate",
                headerName: "Tax Rate",
                fieldName: "tax_rate",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
            {
                key: "tax_state",
                headerName: "Tax State",
                fieldName: "tax_state",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },

            {
                key: "tax_country",
                headerName: "Tax Country",
                fieldName: "tax_country",
                enableSorting: true,
                renderType: RenderType.CUSTOM_RENDER,
            },
        ],

        items: taxInfoList,
        onPageChange: (newPageNumber: number) => {
            setPagination({ ...pagination, pageNumber: newPageNumber });
        },
        onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
            setPagination({
                pageNumber: pageNumber,
                rowsPerPage: rowsPerPage,
            });
        },
    };


    React.useEffect(() => {
        dispatch(
            fetchTaxInfoListAsync({
                page: pagination.pageNumber,
                rowsPerPage: pagination.rowsPerPage,
            }),
        );
    }, [pagination]);

    React.useEffect(() => {
        return () => {
            dispatch(clearTaxInfoListSync());
        };
    }, []);

  

    return (
        <PageContainer title="Tax Information" description='inner page' >
            <Stack direction="row" justifyContent="space-between" alignItems="center" my={2} >
                <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                    <Typography variant='h2'>Tax</Typography>
                    {/* <ControlledCustomSelect
                        label="Search by Users"
                        options={[
                            { label: "All", value: "ALL" },
                        ]}
                        value={dateFilter}
                        onChange={(evt) => setDateFilter(evt.target.value as string)}
                        sx={{ minWidth: 120 }}
                        fullWidth size="small" />
                    <ControlledCustomSelect
                        label="Search by Date"
                        options={[
                            { label: "All", value: "ALL" },
                            { label: "Today", value: moment().format("yyyy-MM-DD") },
                            { label: "Yesterday", value: moment().subtract(1, "day").format("yyyy-MM-DD") },
                            { label: "Custom", value: "CUSTOM" },
                        ]}
                        value={dateFilter}
                        onChange={(evt) => setDateFilter(evt.target.value as string)}
                        sx={{ minWidth: 120 }}
                        fullWidth size="small" />

                    {customDateDialog && <CustomDatePicker
                        label="Select Date"
                        fullWidth
                        fieldName="reservation_date"
                        value={customDate || ""}
                        onChange={(newValue, formattedDate) => {
                            setCustomDate(formattedDate);
                        }}
                    />} */}
                </Stack>
                <CustomButton
                    variant="contained"
                    color="primary"
                    sx={{
                        display: "flex",
                        marginLeft: "auto",
                    }}
                    onClick={() => setOpenUpsertDialog(defaultTaxInfo)}
                >
                    Add Tax Info
                </CustomButton>
            </Stack>
            <DataTable {...dataTableProps} />

            {openUpsertDialog &&
                <UpsertTaxInfoDialog
                    open={true}
                    taxInfo={openUpsertDialog}
                    onClose={() => setOpenUpsertDialog(null)}
                />
            }
        </PageContainer>
    );
}
